module.exports = __webpack_public_path__ + "static/media/Sauron.28039756.jpg";